export default __webpack_public_path__ + "static/media/forgotpassword.bfd14f5a.svg";